// --- START OF MODIFIED FILE src/Components/PopupBanner/Popup.jsx ---
import React, { useState, useEffect } from "react";
import "./Popup.css";

import popupImg from "../../Assets/newsletter-popup.jpg";

const Popup = () => {
  const [isVisible, setIsVisible] = useState(false); // Start hidden
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Check if the popup has been dismissed in this session
    const popupDismissedThisSession = sessionStorage.getItem('popupDismissedThisSession');

    if (!popupDismissedThisSession) {
      // If not dismissed, show it after a short delay
      // This allows the main page layout (Header, etc.) to render first
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500); // Delay of 1.5 seconds, adjust as needed

      // Cleanup the timer if the component unmounts before the timer fires
      return () => clearTimeout(timer);
    }
  }, []); // Empty dependency array ensures this runs only once after initial mount

  const handleClose = () => {
    setFadeOut(true);
    setTimeout(() => {
      setIsVisible(false);
      // Mark that the popup has been dismissed for this session
      sessionStorage.setItem('popupDismissedThisSession', 'true');
    }, 300); // This timeout should match your fade-out animation duration
  };

  // If not visible, render nothing
  if (!isVisible) {
    return null;
  }

  return (
    <div className="popup-overlay"> {/* This is the full-screen overlay */}
      <div className={`popup-content ${fadeOut ? "fade-out" : ""}`}>
        <button className="close-button" onClick={handleClose}>
          ×
        </button>
        <div className="popup-left">
          <img src={popupImg} alt="Newsletter" />
        </div>
        <div className="popup-right">
          <h2>Sign Up to Our Newsletter</h2>
          <p>
            Be the first to get the latest news about trends, promotions, and
            much more!
          </p>
          <form>
            <input type="email" placeholder="Your email address" required />
            <button type="submit">JOIN</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Popup;
// --- END OF MODIFIED FILE src/Components/PopupBanner/Popup.jsx ---